import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  style: {
    "background-color": "#f7f7f7",
    "padding-bottom": "10px"
  }
};
const _hoisted_2 = {
  class: "news-content"
};
const _hoisted_3 = {
  class: "nav-link"
};
const _hoisted_4 = {
  class: "main-content",
  style: {
    "min-height": "60vh"
  }
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  class: "documentTitle"
};
const _hoisted_7 = {
  style: {
    "line-height": "20px",
    "text-align": "center",
    "color": "#999",
    "padding": "20px 0px 5px 0px"
  }
};
const _hoisted_8 = {
  class: "ql-snow article-quill-wrap"
};
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
  key: 1
};
import FriendLink from "./components/friendLink.vue";
import { getProvincesDetail } from "@/api/home";
import { breadCrumb } from "@/utils/dic";
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import { getArticleDetail } from "@/api/home";
import { getCurrentInstance, ref } from "vue";
export default {
  __name: 'articleDetail',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    let queryParams = ref({});
    const route = useRoute();
    const router = useRouter();
    let breadName = ref("");
    watch(() => route.query.type, val => {
      console.log("val", val);
      val ? breadName.value = breadCrumb[val].name + ">" + breadCrumb[val].subName : breadName.value = "";
    }, {
      immediate: true
    });
    let artInfo = ref({});
    function getArticleInfo() {
      const id = route.query.id;
      if (!id) {
        proxy.$message.error("未获取到正确的文章id");
        return;
      }
      getArticleDetail(id).then(res => {
        if (res.success) {
          artInfo.value = res.data;
        } else {
          proxy.$message.error(res.message);
        }
      });
    }
    getArticleInfo();
    let friendlyLinks = ref([]);
    const provinceInfo = JSON.parse(sessionStorage.getItem("provinceInfo")) || {};
    function getProvinceEntranceInfo() {
      if (!provinceInfo.linkCode) {
        return;
      }
      getProvincesDetail({
        linkCode: provinceInfo.linkCode
      }).then(res => {
        if (res.success) {
          friendlyLinks.value = res.data.friendlyLinks;
        } else {
          proxy.$message.error(res.message);
        }
      });
    }
    getProvinceEntranceInfo();
    function handleGo() {
      console.log("点击返回", route.query.type);
      var url = `/news?type=${route.query.type}`;
      router.push(url);
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_result = _resolveComponent("el-result");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(Header), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createTextVNode(" 当前位置： ", -1)), _cache[1] || (_cache[1] = _createElementVNode("a", {
        href: "/"
      }, "首页", -1)), _createTextVNode(" > " + _toDisplayString(_unref(breadName)), 1)]), _createElementVNode("div", _hoisted_4, [_unref(artInfo).id ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(artInfo).title), 1), _createElementVNode("p", _hoisted_7, [_createElementVNode("span", null, "日期：" + _toDisplayString(_unref(artInfo).publishTime), 1)]), _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        class: "ql-editor article-quill-body",
        style: {
          "letter-spacing": "1px",
          "line-height": "1.6"
        },
        innerHTML: _unref(artInfo).content
      }, null, 8, _hoisted_9)])])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_result, {
        icon: "warning",
        title: "您访问的内容不存在"
      }, {
        extra: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleGo
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("点击返回上一级", -1)]))]),
          _: 1
        })]),
        _: 1
      })]))])])]), _createVNode(Footer)], 64);
    };
  }
};